import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PersonService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Person');
	}
	loadBirthdays(): Observable<ePM.Logic.Person[]> {
		return this.myBaseService.loadAll(this.url + '/Birthdays');
	}
	loadAnniversaries(): Observable<any[]> {
		return this.myBaseService.loadAll(this.url + '/Anniversaries');
	}
    loadAllEvenDeleted(id: System.Guid): Observable<ePM.Logic.Person[]> {
        return this.myBaseService.loadAll(this.url + '/Company/' + (id || '') + '?includeAll=true');
    }
	loadAll(id: System.Guid): Observable<ePM.Logic.Person[]> {
		return this.myBaseService.loadAll(this.url + '/Company/' + (id || ''));
	}
	
	save(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.Person> {
		return this.myBaseService.save(tempItem, this.url);
	}

	add(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.Person> {
		return this.myBaseService.save(tempItem, this.url  +'/Add');
	}
	sendInvite(id: System.Guid): Observable<ePM.Logic.Person> {
		return this.myBaseService.post(null, this.url + '/SendInvite/' + id);
	}
	sendInvites(invites: ePM.Logic.PersonInvite[]): Observable<number> {
		return this.myBaseService.post(invites, this.url + '/Invite');
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.Person> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<ePM.Logic.Person> {
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string): Observable<ePM.Logic.Person[]> {
		return this.myBaseService.loadAll(this.url + '/Search/' + searchTerm);
	}
}
